import { ReactNode } from 'react';

import { Button, Typography, VARIANTS } from 'shared';

type TJournalAddNoteFormSectionOption = {
  isActive: boolean;
  onClick: () => void;
  children: ReactNode;
};

export const JournalAddNoteFormSectionOption = ({
  isActive,
  onClick,
  children,
}: TJournalAddNoteFormSectionOption) => (
  <Button
    onClick={onClick}
    color={isActive ? VARIANTS.PRIMARY : 'gray'}
    variant={isActive ? 'solid' : 'outline'}
    size="xs"
    _active={{
      outline: 'none',
    }}
  >
    <Typography
      textStyle="xs"
      color={isActive ? 'white' : 'black'}
      cropped={true}
      wordBreak="break-word"
    >
      {children}
    </Typography>
  </Button>
);
